import Vue from 'vue';
import Router from 'vue-router';
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router);

export default new Router({
  routes: [{
    path: '/',
    redirect: '/page/Dashboard',
    name: '首页'
  },
  {
    path: '/',
    component: resolve => require(['../components/common/Home.vue'], resolve),
    meta: {
      title: '首页'
    },
    children: [{
      path: '/page/Dashboard',
      component: resolve => require(['../components/page/Dashboard.vue'], resolve),
      meta: {
        title: '系统首页',
        idj: ''
      },
      name: '首页'
    },
    // 物业首页
    {
      path: '/components/page/secretary',
      component: resolve => require(['../components/page/secretary.vue'], resolve),
      meta: {
        title: '物业',
        idj: ''
      },
      name: '物业'
    },
    // 工作人员
    {
      path: '/components/page/work',
      component: resolve => require(['../components/page/work.vue'], resolve),
      meta: {
        title: '工作人员',
        idj: ''
      },
      name: '工作人员'
    },
    {
      path: '/page/Icon',
      component: resolve => require(['../components/page/Icon.vue'], resolve),
      meta: {
        title: '自定义图标',
        idj: ''
      },
      name: '自定义图标'
    },
    {
      path: '/page/BaseTable',
      component: resolve => require(['../components/page/BaseTable.vue'], resolve),
      meta: {
        title: '基础表格',
        idj: ''
      },
      name: '基础表格'
    },
    /**收款单中间表 */
    {
      path: '/module/aicty/wechatpaylog/wechatpaylog_List',
      component: resolve => require(['../module/aicty/wechatpaylog/wechatpaylog_List.vue'], resolve),
      meta: {
        title: '支付记录',
        idj: ''
      },
      name: ' 支付记录'
    },
     /**sms短信配置 */
     {
      path: '/module/aicty/ctysmsconfig/smsconfig_List',
      component: resolve => require(['../module/aicty/ctysmsconfig/smsconfig_List.vue'], resolve),
      meta: {
        title: '短信配置',
        idj: ''
      },
      name: ' 短信配置'
    },
      /**微信支付配置 */
      {
        path: '/module/aicty/ctyjsapiconfig/jsapiconfig_List',
        component: resolve => require(['../module/aicty/ctyjsapiconfig/jsapiconfig_List.vue'], resolve),
        meta: {
          title: '支付配置',
          idj: ''
        },
        name: ' 支付配置'
      },

       /**疫情 */
       {
        path: '/module/aicty/ctyepidemicsituation/treefrom_List',
        component: resolve => require(['../module/aicty/ctyepidemicsituation/treefrom_List.vue'], resolve),
        meta: {
          title: '疫情防控',
          idj: ''
        },
        name: ' 疫情防控'
      },
    /**
     * 楼栋档案
     */

    {
      path: '/module/aicty/proBuilder/proBuilder_List',
      component: resolve => require(['../module/aicty/proBuilder/proBuilder_List.vue'], resolve),
      meta: {
        title: '楼栋档案',
        idj: ''
      },
      name: '楼栋档案'
    },

    /**
     * 企业档案
     */
    {
      path: '/module/aicty/ctyEnterprise/ctyEnterprise_List',
      component: resolve => require(['../module/aicty/ctyEnterprise/ctyEnterprise_List.vue'], resolve),
      meta: {
        title: '企业档案',
        idj: ''
      },
      name: '企业档案'
    },

    /**
     * 案件
     */
    {
      path: '/module/aicty/eventType/eventType',
      component: resolve => require(['../module/aicty/eventType/eventType_Form.vue'], resolve),
      meta: {
        title: '事件类型',
        idj: ''
      },
      name: '事件类型'
    },

    /**
     * 案件登记
     */
    {
      path: '/module/aicty/eventRegister/eventRegister_List',
      component: resolve => require(['../module/aicty/eventRegister/eventRegister_List.vue'], resolve),
      meta: {
        title: '事件登记',
        idj: ''
      },
      name: '事件登记'
    },
      /**
       *  事件跟踪
       */
      {
        path: '/module/aicty/eventFollow/eventFollow_List',
        component: resolve => require(['../module/aicty/eventFollow/eventFollow_List.vue'], resolve),
        meta: {
          title: '事件跟踪',
          idj: ''
        },
        name: '事件跟踪'
      },
    /**
     * 计生事项登记
     */
    {
      path: '/module/aicty/eventInfo/eventInfo_List',
      component: resolve => require(['../module/aicty/eventInfo/eventInfo_List.vue'], resolve),
      meta: {
        title: '计生事项登记',
        idj: ''
      },
      name: '计生事项登记'
    },
    /**
     * 民政事项登记
     */
    {
      path: '/module/aicty/eventInfo/mz_eventInfo_List',
      component: resolve => require(['../module/aicty/eventInfo/mz_eventInfo_List.vue'], resolve),
      meta: {
        title: '民政事项登记',
        idj: ''
      },
      name: '民政事项登记'
    },
    /**
     * 计生特殊家庭信息
     */
    {
      path: '/module/aicty/specialFamily/sepcialFamily_List',
      component: resolve => require(['../module/aicty/ctySpecialFamily/sepcialFamily_List.vue'], resolve),
      meta: {
        title: '计生特殊家庭',
        idj: ''
      },
      name: '计生特殊家庭'
    },

    /**
     * 退役军人及军属档案
     */
    {
      path: '/module/aicty/ctyretiresoldier/ctyretiresoldier_List',
      component: resolve => require(['../module/aicty/ctyretiresoldier/ctyretiresoldier_List.vue'], resolve),
      meta: {
        title: '退役军人管理',
        idj: ''
      },
      name: '退役军人管理'
    },

    {
      path: '/module/aicty/ctyLowincome/ctyLowincome_List',
      component: resolve => require(['../module/aicty/ctyLowincome/ctyLowincome_List.vue'], resolve),
      meta: {
        title: '低保发放详单',
        idj: ''
      },
      name: '低保发放详单'
    },
    /**
     *  残疾人名单
     */
    {
      path: '/module/aicty/ctydisabledPeople/ctydisabledPeople_List',
      component: resolve => require(['../module/aicty/ctydisabledPeople/disabledPeople_List.vue'], resolve),
      meta: {
        title: '残疾人名单',
        idj: ''
      },
      name: '残疾人名单'
    },


  
    /**
     * 工单分类
     */
    {
      path: '/module/aicty/proworkordertype/proworkordertype_List',
      component: resolve => require(['../module/aicty/proworkordertype/proworkordertype_List.vue'], resolve),
      meta: {
        title: '服务分类',
        idj: ''
      },
      name: '服务分类'
    },

    /**
     * 服务项目
     */
    {
      path: '/module/aicty/proserviceproject/serviceProject_List',
      component: resolve => require(['../module/aicty/proserviceproject/serviceProject_List.vue'], resolve),
      meta: {
        title: '服务项目',
        idj: ''
      },
      name: '服务项目'
    },

    /**
     * 服务工单
     */
    {
      path: '/module/aicty/proServiceWork/serviceWork_List',
      component: resolve => require(['../module/aicty/proServiceWork/serviceWork_List.vue'], resolve),
      meta: {
        title: '服务工单',
        idj: ''
      },
      name: '服务工单'
    },

    /**
     * 基础档案
     */
    {
      path: '/module/aicty/proRoom/proRoom_Form',
      component: resolve => require(['../module/aicty/proRoom/proRoom_Form.vue'], resolve),
      meta: {
        title: '房源档案',
        idj: ''
      },
      name: '房源档案'
    },
    {
      path: '/module/aicty/proRoomstatus/proRoomstatus_Form',
      component: resolve => require(['../module/aicty/proRoomstatus/proRoomstatus_Form.vue'], resolve),
      meta: {
        title: '房源状态',
        idj: ''
      },
      name: '房源状态'
    },
    {
      path: '/module/aicty/proMeasureUnit/proMeasureUnit_List',
      component: resolve => require(['../module/aicty/proMeasureUnit/proMeasureUnit_List.vue'], resolve),
      meta: {
        title: '计量单位',
        idj: ''
      },
      name: '计量单位'
    },


    {
      path: '/module/aicty/proBusformat/proBusformat_Form',
      component: resolve => require(['../module/aicty/proBusformat/proBusformat_Form.vue'], resolve),
      meta: {
        title: '业态档案',
        idj: ''
      },
      name: '业态档案'
    },
    {
      path: '/module/aicty/partyDuty/partyDuty_Form',
      component: resolve => require(['../module/aicty/partyDuty/partyDuty_Form.vue'], resolve),
      meta: {
        title: '党内职务',
        idj: ''
      },
      name: '党内职务'
    },
    {
      path: '/module/aicty/partyOrg/partyOrg_Form',
      component: resolve => require(['../module/aicty/partyOrg/partyOrg_Form.vue'], resolve),
      meta: {
        title: '党组织',
        idj: ''
      },
      name: '党组织'
    },
    {
      path: '/module/aicty/partyMember/treeList_List',
      component: resolve => require(['../module/aicty/partyMember/treeList_List.vue'], resolve),
      meta: {
        title: '党员档案',
        idj: ''
      },
      name: '党员档案'
    },
    {
      path: '/module/aicty/partyMember/relveFamily/treeList_List',
      component: resolve => require(['../module/aicty/partyMember/relveFamily/treeList_List.vue'], resolve),
      meta: {
        title: '党员联户',
        idj: ''
      },
      name: '党员联户'
    },
    {
      path: '/module/aicty/ctyPartyformula/ctyPartyformula_List',
      component: resolve => require(['../module/aicty/ctyPartyformula/ctyPartyformula_List.vue'], resolve),
      meta: {
        title: '党费基数',
        idj: ''
      },
      name: '党费基数'
    },
    {
      path: '/module/aicty/ctyPartycostreg/listForm_List',
      component: resolve => require(['../module/aicty/ctyPartycostreg/listForm_List.vue'], resolve),
      meta: {
        title: '党费缴纳',
        idj: ''
      },
      name: '党费缴纳'
    },
    {
      path: '/module/aicty/ctyPartycostregReport/ctyPartycostregReportList',
      component: resolve => require(['../module/aicty/ctyPartycostregReport/ctyPartycostregReportList.vue'], resolve),
      meta: {
        title: '党费缴纳统计报表',
        idj: ''
      },
      name: '党费缴纳统计报表'
    },
    {
      path: '/module/aicty/proProject/proProject_Form',
      component: resolve => require(['../module/aicty/proProject/proProject_Form.vue'], resolve),
      meta: {
        title: '项目档案',
        idj: ''
      },
      name: '项目档案'
    },
    {
      path: '/module/aicty/populregister/listForm_List',
      component: resolve => require(['../module/aicty/populregister/listForm_List.vue'], resolve),
      meta: {
        title: '人口档案',
        idj: '',
        pageCode: 'populregister',
      },
      name: '人口档案'
    },
    {
      path: '/module/aicty/populregister/plannedParenthood',
      component: resolve => require(['../module/aicty/populregister/plannedParenthood.vue'], resolve),
      meta: {
        title: '计生人口管理',
        idj: '',
        pageCode: 'plannedParenthood',
      },
      name: '计生人口管理',
    },
    {
      path: '/module/aicty/populregister/civilAffairs',
      component: resolve => require(['../module/aicty/populregister/civilAffairs.vue'], resolve),
      meta: {
        title: '民政人口管理',
        idj: '',
        pageCode: 'civilAffairs',
      },
      name: '民政人口管理',
    },
    {
      path: '/module/aicty/onlychild/onlychild_List',
      component: resolve => require(['../module/aicty/onlychild/onlychild_List.vue'], resolve),
      meta: {
        title: '独生子女登记',
        idj: ''
      },
      name: '独生子女登记'
    },
    {
      path: '/module/aicty/oldpeople/oldpeople_List',
      component: resolve => require(['../module/aicty/oldpeople/oldpeople_List.vue'], resolve),
      meta: {
        title: '老年人口登记',
        idj: ''
      },
      name: '老年人口登记'
    },
    {
      path: '/module/aicty/member/member_List',
      component: resolve => require(['../module/aicty/member/member_List.vue'], resolve),
      meta: {
        title: '党建人口管理',
        idj: ''
      },
      name: '党建人口管理'
    },
    {
      path: '/module/aicty/proLabelallot',
      component: resolve => require(['../module/aicty/proLabelallot/treeList_List.vue'], resolve),
      meta: {
        title: '标签标记',
        idj: ''
      },
      name: '标签标记'
    },
    {
      path: '/module/aicty/importantPopul',
      component: resolve => require(['../module/aicty/proLabelallot/importantPopul.vue'], resolve),
      meta: {
        title: '重点人口管理',
        idj: '',
        pageCode: 'importantPopul',
      },
      name: '重点人口管理'
    },
    {
      path: '/module/aicty/customerDoc/listForm_List',
      component: resolve => require(['../module/aicty/customerDoc/listForm_List.vue'], resolve),
      meta: {
        title: '客户档案',
        idj: ''
      },
      name: '客户档案'
    },
    {
      path: '/module/aicty/proHouseregis/proHouseregis_Form',
      component: resolve => require(['../module/aicty/proHouseregis/proHouseregis_Form.vue'], resolve),
      meta: {
        title: '房客关系',
        idj: ''
      },
      name: '房客关系'
    },
    {
      path: '/module/aicty/proLabel/treeForm_Form',
      component: resolve => require(['../module/aicty/proLabel/treeForm_Form.vue'], resolve),
      meta: {
        title: '标签档案',
        idj: ''
      },
      name: '标签档案'
    },
    {
      path: '/module/aicty/proServicenter/proServicenter_List',
      component: resolve => require(['../module/aicty/proServicenter/proServicenter_List.vue'], resolve),
      meta: {
        title: '服务中心',
        idj: ''
      },
      name: '服务中心'
    },
    {
      path: '/module/aicty/proCostsubj/proCostsubj_Form',
      component: resolve => require(['../module/aicty/proCostsubj/proCostsubj_Form.vue'], resolve),
      meta: {
        title: '收费项目',
        idj: ''
      },
      name: '收费项目'
    },
    {
      path: '/module/aicty/proCostnorm/proCostnorm_Form',
      component: resolve => require(['../module/aicty/proCostnorm/proCostnorm_Form.vue'], resolve),
      meta: {
        title: '收费标准',
        idj: ''
      },
      name: '收费标准'
    },
    {
      path: '/module/aicty/proCustcostnorm/proCustcostnorm_Form',
      component: resolve => require(['../module/aicty/proCustcostnorm/proCustcostnorm_Form.vue'], resolve),
      meta: {
        title: '房产收费标准',
        idj: ''
      },
      name: '房产收费标准'
    },
    {
      path: '/module/aicty/proReceivable/proReceivableList',
      component: resolve => require(['../module/aicty/proReceivable/proReceivableList.vue'], resolve),
      meta: {
        title: '费用清单',
        idj: ''
      },
      name: '费用清单',
    },
    {
      path: '/module/aicty/proReceivadjust/proReceivadjustList',
      component: resolve => require(['../module/aicty/proReceivadjust/proReceivadjustList.vue'], resolve),
      meta: {
        title: '费用调整',
        idj: ''
      },
      name: '费用调整'
    },
    {
      path: '/module/aicty/proReceive/proReceiveList',
      component: resolve => require(['../module/aicty/proReceive/proReceiveList.vue'], resolve),
      meta: {
        title: '收款登记',
        idj: ''
      },
      name: '收款登记'
    },
    {
      path: '/module/aicty/proReceivcalc/listForm_List',
      component: resolve => require(['../module/aicty/proReceivcalc/listForm_List.vue'], resolve),
      meta: {
        title: '费用计算',
        idj: ''
      },
      name: '费用计算'
    },
    {
      path: '/module/aicty/proreceiptdeliver/proreceiptdeliver_List',
      component: resolve => require(['../module/aicty/proreceiptdeliver/proreceiptdeliver_List.vue'], resolve),
      meta: {
        title: '收款交接',
        idj: ''
      },
      name: '收款交接'
    },
    {
      path: '/module/aicty/prostandingbook/prostandingbook_List',
      component: resolve => require(['../module/aicty/prostandingbook/prostandingbook_List.vue'], resolve),
      meta: {
        title: '物业费台账',
        idj: ''
      },
      name: '物业费台账'
    },
    {
      path: '/module/aicty/houseTable/houseTable',
      component: resolve => require(['../module/aicty/houseTable/houseTable.vue'], resolve),
      meta: {
        title: '房产销控图',
        idj: ''
      },
      name: '房产销控图'
    },
    {
      path: '/module/aicty/ctyGrid/ctyGrid_List',
      component: resolve => require(['../module/aicty/ctyGrid/ctyGrid_List.vue'], resolve),
      meta: {
        title: '网格档案',
        idj: ''
      },
      name: '网格档案'
    },
    // 基本档案下的职位配置
    {
      path: '/module/aicty/sysPost/sysPostList',
      component: resolve => require(['../module/aicty/sysPost/sysPostList.vue'], resolve),
      meta: {
        title: '岗位设置',
        idj: ''
      },
      name: '岗位设置'
    },
    {
      path: '/module/aicty/proPerson/proPerson_List',
      component: resolve => require(['../module/aicty/proPerson/proPerson_List.vue'], resolve),
      meta: {
        title: '人事档案',
        idj: ''
      },
      name: '人事档案'
    },
    {
      path: '/module/aicty/proRewardPunish/proRewardPunish_List',
      component: resolve => require(['../module/aicty/proRewardPunish/proRewardPunish_List.vue'], resolve),
      meta: {
        title: '奖惩登记',
        idj: ''
      },
      name: '奖惩登记'
    },
    //设备管理-设备分类
    {
      path: '/module/aicty/proDevicetype/proDevicetype_Form',
      component: resolve => require(['../module/aicty/proDevicetype/proDevicetype_Form.vue'], resolve),
      meta: {
        title: '设备分类',
        idj: ''
      },
      name: '设备分类'
    },
    {
      path: '/module/aicty/proDevice/proDevice_List',
      component: resolve => require(['../module/aicty/proDevice/proDevice_List.vue'], resolve),
      meta: {
        title: '设备档案',
        idj: ''
      },
      name: '设备档案'
    },
    {
      path: '/module/aicty/proDeviceupkeep/proDeviceupkeep_List',
      component: resolve => require(['../module/aicty/proDeviceupkeep/proDeviceupkeep_List.vue'], resolve),
      meta: {
        title: '设备保养',
        idj: ''
      },
      name: '设备保养'
    },
    {
      path: '/module/aicty/roomStatus',
      component: resolve => require(['../module/aicty/roomStatus/roomStatus.vue'], resolve),
      meta: {
        title: '社区房态图',
        idj: '',
        pageCode: 'roomStatus',
      },
      name: '社区房态图'
    },
    {
      path: '/module/aicty/gridGraph',
      component: resolve => require(['../module/aicty/gridGraph/gridGraph.vue'], resolve),
      meta: {
        title: '社区网格图',
        idj: ''
      },
      name: '社区网格图'
    },
    {
      path: '/module/aicty/ctyGridGraph/listForm_List',
      component: resolve => require(['../module/aicty/ctyGridGraph/listForm_List.vue'], resolve),
      meta: {
        // title: '网格图管理',
        title: '辖区地图',
        idj: ''
      },
      name: '辖区地图'
    },
    {
      path: '/module/aicty/ctynoticetype',
      component: resolve => require(['../module/aicty/ctynoticetype/noticeType_Form.vue'], resolve),
      meta: {
        title: '通知公告分类',
        idj: ''
      },
      name: '通知公告分类'
    },
    {
      path: '/module/aicty/ctynotice',
      component: resolve => require(['../module/aicty/ctynotice/noticeForm_List.vue'], resolve),
      meta: {
        title: '通知公告内容',
        idj: ''
      },
      name: '通知公告内容'
    },
    {
      path: '/page/Tabs',
      component: resolve => require(['../components/page/Tabs.vue'], resolve),
      meta: {
        title: '消息通知',
        idj: ''
      },
      name: '消息通知'
    },
    {
      path: '/page/BaseForm',
      component: resolve => require(['../components/page/BaseForm.vue'], resolve),
      meta: {
        title: '基本表单',
        idj: ''
      },
      name: '基本表单'
    },
    {
      // 富文本编辑器组件
      path: '/page/VueEditor',
      component: resolve => require(['../components/page/VueEditor.vue'], resolve),
      meta: {
        title: '富文本编辑器',
        idj: ''
      },
      name: '富文本编辑器'
    },
    {
      // 富文本编辑器组件
      path: '/page/VueEditorDB',
      component: resolve => require(['../components/page/VueEditorDB.vue'], resolve),
      meta: {
        title: '富文哈哈哈器',
        idj: ''
      },
      name: '富文哈哈哈器'
    },
    {
      // markdown组件
      path: '/page/Markdown',
      component: resolve => require(['../components/page/Markdown.vue'], resolve),
      meta: {
        title: 'markdown编辑器',
        idj: ''
      },
      name: 'markdown编辑器'
    },
    {
      // 图片上传组件
      path: '/page/Upload',
      component: resolve => require(['../components/page/Upload.vue'], resolve),
      meta: {
        title: '文件上传',
        idj: ''
      },
      name: '文件上传'
    },
    {
      // 导出列表数据DEMO
      path: '/page/exportTable',
      component: resolve => require(['../components/page/exportTable.vue'], resolve),
      meta: {
        title: '文件上传',
        idj: ''
      },
      name: '文件上传'
    },
    {
      // 导出列表数据DEMO
      path: '/page/exportTable',
      component: resolve => require(['../components/page/exportTable.vue'], resolve),
      meta: {
        title: '文件上传',
        idj: ''
      },
      name: '文件上传'
    },
    {
      // vue-schart组件
      path: '/page/BaseCharts',
      component: resolve => require(['../components/page/BaseCharts.vue'], resolve),
      meta: {
        title: 'schart图表',
        idj: ''
      },
      name: 'schart图表'
    },
    {
      // 拖拽列表组件
      path: '/page/DragList',
      component: resolve => require(['../components/page/DragList.vue'], resolve),
      meta: {
        title: '拖拽列表',
        idj: ''
      },
      name: '拖拽列表'
    },
    {
      // 拖拽Dialog组件
      path: '/page/DragDialog',
      component: resolve => require(['../components/page/DragDialog.vue'], resolve),
      meta: {
        title: '拖拽弹框',
        idj: ''
      },
      name: '拖拽弹框'
    },
    {
      // 模板一
      path: '/module/mode/modeOne/modeListOne',
      component: resolve => require(['../module/mode/modeOne/modeListOne.vue'], resolve),
      meta: {
        title: '模板一',
        permission: false,
        idj: ''
      },
      name: '模板一'
    },
    {
      // 模板二
      path: '/module/mode/modeTwo/modeListTwo',
      component: resolve => require(['../module/mode/modeTwo/modeListTwo.vue'], resolve),
      meta: {
        title: '模板二',
        permission: false,
        idj: ''
      },
      name: '模板二'
    },
    {
      // 权限页面
      path: '/permission',
      component: resolve => require(['../components/page/Permission.vue'], resolve),
      meta: {
        title: '权限测试',
        permission: true,
        idj: ''
      },
      name: '权限测试'
    },
    {
      // 菜单配置
      path: '/module/system/sysMenu/sysMenuList',
      component: resolve => require(['../module/system/sysMenu/sysMenuList.vue'], resolve),
      meta: {
        title: '菜单配置',
        permission: false,
        idj: ''
      },
      name: '菜单配置'
    },
    {
      // 账号配置
      path: '/module/system/sysUser/sysUserList',
      component: resolve => require(['../module/system/sysUser/sysUserList.vue'], resolve),
      meta: {
        title: '账号配置',
        permission: false,
        keepAlive: true,
        idj: ''
      },
      name: '账号配置'
    },
    {
      // 部门配置
      path: '/module/system/sysDepartment/sysDepartmentList',
      component: resolve => require(['../module/system/sysDepartment/sysDepartmentList.vue'], resolve),
      meta: {
        title: '部门配置',
        permission: false,
        idj: ''
      },
      name: '部门配置'
    },
    {
      // 操作日志
      path: '/module/system/sysLog/sysLogList',
      component: resolve => require(['../module/system/sysLog/sysLogList.vue'], resolve),
      meta: {
        title: '操作日志',
        permission: false,
        idj: ''
      },
      name: '操作日志'
    },
    {
      // 资讯管理
      path: '/module/system/sysInformationManager/sysInfoList',
      component: resolve => require(['../module/system/sysInformationManager/sysInfoList.vue'], resolve),
      meta: {
        title: '资讯管理',
        permission: true,
        idj: ''
      },
      name: '资讯管理'
    },
    {
      // 自定义爬虫
      path: '/module/system/sysWebmagic/sysWebmagicList',
      component: resolve => require(['../module/system/sysWebmagic/sysWebmagicList.vue'], resolve),
      meta: {
        title: '自定义爬虫',
        permission: true,
        idj: ''
      },
      name: '自定义爬虫'
    },
    {
      // 登录日志
      path: '/module/system/sysLogin/sysLoginList',
      component: resolve => require(['../module/system/sysLogin/sysLoginList.vue'], resolve),
      meta: {
        title: '登录日志',
        permission: false,
        idj: ''
      },
      name: '登录日志'
    },
    {
      // 消息服务
      path: '/module/system/sysMessage/sysMessageList',
      component: resolve => require(['../module/system/sysMessage/sysMessageList.vue'], resolve),
      meta: {
        title: '消息服务',
        permission: true,
        idj: ''
      },
      name: '消息服务'
    },
    {
      // 岗位配置
      path: '/module/system/sysPost/sysPostList',
      component: resolve => require(['../module/system/sysPost/sysPostList.vue'], resolve),
      meta: {
        title: '岗位配置',
        permission: false,
        idj: ''
      },
      name: '岗位配置'
    },
    {
      // 字典清单
      path: '/module/system/sysDic/sysDicList',
      component: resolve => require(['../module/system/sysDic/sysDicList.vue'], resolve),
      meta: {
        title: '字典清单',
        permission: false,
        idj: ''
      },
      name: '字典清单'
    },
    {
      // 按钮配置
      path: '/module/system/sysButtonConfig/sysButtonConfigList',
      component: resolve => require(['../module/system/sysButtonConfig/sysButtonConfigList.vue'], resolve),
      meta: {
        title: '按钮配置',
        permission: false,
        idj: ''
      },
      name: '按钮配置'
    },
    {
      // 定时任务
      path: '/module/system/sysTask/sysTaskList',
      component: resolve => require(['../module/system/sysTask/sysTaskList.vue'], resolve),
      meta: {
        title: '定时任务',
        permission: false,
        idj: ''
      },
      name: '定时任务'
    },
    {
      // 角色岗位
      path: '/module/system/sysRole/sysRoleList',
      component: resolve => require(['../module/system/sysRole/sysRoleList.vue'], resolve),
      meta: {
        title: '角色配置',
        permission: true,
        idj: ''
      },
      name: '角色配置'
    },
    {
      // 组织
      path: '/module/system/sysOrg/sysOrgList',
      component: resolve => require(['../module/system/sysOrg/sysOrgList.vue'], resolve),
      meta: {
        title: '组织',
        permission: true,
        idj: ''
      },
      name: '组织'
    },
    {
      // 服务器资源信息
      path: '/module/system/sysSmb/sysSmbList',
      component: resolve => require(['../module/system/sysSmb/sysSmbList.vue'], resolve),
      meta: {
        title: '服务器资源信息',
        permission: true,
        idj: ''
      },
      name: '服务器资源信息'
    },
    {
      // 服务监控
      path: '/module/system/sysMonitor/sysMonitorList',
      component: resolve => require(['../module/system/sysMonitor/sysMonitorList.vue'], resolve),
      meta: {
        title: '服务监控',
        permission: true,
        idj: ''
      },
      name: '服务监控'
    },
    {
      // 监控配置
      path: '/module/system/sysDruid/sysDruidList',
      component: resolve => require(['../module/system/sysDruid/sysDruidList.vue'], resolve),
      meta: {
        title: '监控配置',
        permission: true,
        idj: ''
      },
      name: '监控配置'
    },
    {
      // 监控配置
      path: '/module/system/sysNotice/sysNoticeList',
      component: resolve => require(['../module/system/sysNotice/sysNoticeList.vue'], resolve),
      meta: {
        title: '系统公告',
        permission: true,
        idj: ''
      },
      name: '系统公告'
    },
    {
      // 权限验证规则串配置
      path: '/module/system/sysShiroIni/interceptVuleManager',
      component: resolve => require(['../module/system/sysShiroIni/interceptVuleManager.vue'], resolve),
      meta: {
        title: '权限验证规则串配置',
        permission: true,
        idj: ''
      },
      name: '权限验证规则串配置'
    },
    {
      // 职称档案
      path: '/module/system/humanResources/titleArchives/titleArchivesList',
      component: resolve => require(['../module/system/humanResources/titleArchives/titleArchivesList.vue'], resolve),
      meta: {
        title: '职称档案',
        permission: true,
        idj: ''
      },
      name: '职称档案'
    },
    {
      // 执业资格分类
      path: '/module/system/humanResources/practiceClassification/practiceList',
      component: resolve => require(['../module/system/humanResources/practiceClassification/practiceList.vue'], resolve),
      meta: {
        title: '执业资格分类',
        permission: true,
        idj: ''
      },
      name: '执业资格分类'
    },
    //业务岗位分类
    {
      path: '/module/system/humanResources/businessPostClassification/businessPostList',
      component: resolve => require(['../module/system/humanResources/businessPostClassification/businessPostList.vue'], resolve),
      meta: {
        title: '业务岗位分类',
        permission: true,
        idj: ''
      },
      name: '业务岗位分类'
    },
    //人事信息登记
    {
      path: '/module/system/humanResources/personnelInformation/personnelInformationList',
      component: resolve => require(['../module/system/humanResources/personnelInformation/personnelInformationList.vue'], resolve),
      meta: {
        title: '人事信息登记',
        permission: true,
        idj: ''
      },
      name: '人事信息登记'
    },
    //附件中心
    {
      path: '/module/system/sysPropertyRightManager/accessoryCentreList',
      component: resolve => require(['../module/system/sysPropertyRightManager/accessoryCentreList.vue'], resolve),
      meta: {
        title: '附件中心',
        permission: true,
        idj: ''
      },
      name: '附件中心'
    },
    //文档管理
    {
      path: '/module/system/sysPropertyRightManager/docManagerList',
      component: resolve => require(['../module/system/sysPropertyRightManager/docManagerList.vue'], resolve),
      meta: {
        title: '文档管理',
        permission: true,
        idj: ''
      },
      name: '文档管理'
    },
    //已发布资讯
    {
      path: '/module/system/sysPropertyRightManager/publishedInformation',
      component: resolve => require(['../module/system/sysPropertyRightManager/publishedInformation.vue'], resolve),
      meta: {
        title: '已发布资讯',
        permission: true,
        idj: ''
      },
      name: '已发布资讯'
    },
    // 资讯管理池
    {
      path: '/module/system/sysPropertyRightManager/informationManagement',
      component: resolve => require(['../module/system/sysPropertyRightManager/informationManagement.vue'], resolve),
      meta: {
        title: '资讯管理池',
        permission: true,
        idj: ''
      },
      name: '资讯管理池'
    },
    //使用pageOffice
    {
      path: '/module/system/sysPageOffice/sysPageOfficeTest',
      component: resolve => require(['../module/system/sysPageOffice/sysPageOfficeTest.vue'], resolve),
      meta: {
        title: '使用pageOffice打开文件',
        permission: true,
        idj: ''
      },
      name: '使用pageOffice打开文件'
    },
    //ExeclUtils测试导出
    {
      path: '/module/system/sysPageOffice/contractOutReasonList',
      component: resolve => require(['../module/system/sysPageOffice/contractOutReasonList.vue'], resolve),
      meta: {
        title: 'ExeclUtils测试导出',
        permission: true,
        idj: ''
      },
      name: 'ExeclUtils测试导出'
    },
    //电子签章
    {
      path: '/module/system/sysPageOffice/electronicSignature/electronicSignatureList',
      component: resolve => require(['../module/system/sysPageOffice/electronicSignature/electronicSignatureList.vue'], resolve),
      meta: {
        title: '电子签章管理',
        permission: true,
        idj: ''
      },
      name: '电子签章管理'
    },
    //个人中心
    {
      path: '/module/system/sysUser/sysUserInfoList',
      component: resolve => require(['../module/system/sysUser/sysUserInfoList.vue'], resolve),
      meta: {
        title: '个人中心',
        permission: true,
        idj: ''
      },
      name: '个人中心'
    },
    //企业通讯录
    {
      path: '/module/system/humanResources/enterpriseAddressBook/enterpriseAddressBookList',
      component: resolve => require(['../module/system/humanResources/enterpriseAddressBook/enterpriseAddressBookList.vue'], resolve),
      meta: {
        title: '企业通讯录',
        permission: true,
        idj: ''
      },
      name: '企业通讯录'
    },
    //文件模板
    {
      path: '/module/system/sysFileTemplate/sysFileTemplate',
      component: resolve => require(['../module/system/sysFileTemplate/sysFileTemplateList.vue'], resolve),
      meta: {
        title: '文件模板',
        permission: true,
        idj: ''
      },
      name: '文件模板'
    },
    // 号段配置
    {
      path: '/module/system/sysNumberRange/sysNumberRangeList',
      component: resolve => require(['../module/system/sysNumberRange/SysNumberRange.vue'], resolve),
      meta: {
        title: '号段配置',
        permission: true,
        idj: ''
      },
      name: '号段配置'
    },
    // 参数配置
    {
      path: '/module/system/sysParameterConfiguration/sysParameterConfigurationList',
      component: resolve => require(['../module/system/sysParameterConfiguration/sysParameterConfigurationList.vue'], resolve),
      meta: {
        title: '参数配置',
        permission: true,
        idj: ''
      },
      name: '参数配置'
    },
    // begin 研发设计
    {
      path: '/module/design/dataModel/dataModelList',
      component: resolve => require(['../module/design/dataModel/dataModelList.vue'], resolve),
      meta: {
        title: '数据模型',
        permission: true,
        idj: ''
      },
      name: '数据模型'
    },
    // end 研发设计
    //功能模块配置
    {
      path: '/module/system/sysFunctionModule/sysFunctionList',
      component: resolve => require(['../module/system/sysFunctionModule/sysFunctionList.vue'], resolve),
      meta: {
        title: '功能模块配置',
        permission: true,
        idj: ''
      },
      name: '功能模块配置'
    },
    {
      // 字段类型维护
      path: '/module/system/fieldType/fieldTypeList',
      component: resolve => require(['../module/system/fieldType/fieldTypeList.vue'], resolve),
      meta: {
        title: '字段类型',
        permission: true,
        idj: ''
      },
      name: '字段类型'
    },
    {
      path: '/module/system/imageScanType/imageScanTypeList',
      component: resolve => require(['../module/system/imageScanType/imageScanTypeList.vue'], resolve),
      meta: {
        title: '影像扫描分类',
        permission: true,
        idj: ''
      },
      name: '影像扫描分类'
    },
    {
      // 影像中心
      path: '/module/system/sysOcx2/sysOcx2-manager',
      component: resolve => require(['../module/system/sysOcx2/sysOcx2ClassifiedManagerList.vue'], resolve),
      meta: {
        title: '影像中心',
        permission: true,
        idj: ''
      },
      name: '影像中心'
    },
    // 在线用户
    {
      path: '/module/system/userMonitoring/listForm_List',
      component: resolve => require(['../module/system/userMonitoring/listForm_List.vue'], resolve),
      meta: {
        title: '在线用户',
        permission: false,
        keepAlive: true,
        idj: ''
      },
      name: '在线用户'
    },
    {
      path: '/module/system/sysFastdfsDocment/sysFastdfsDocmentVideo',
      component: resolve => require(['../module/system/sysFastdfsDocment/sysFastdfsDocmentVideo.vue'], resolve),
      meta: {
        title: '视频/文档管理',
        permission: false,
        keepAlive: true,
        idj: ''
      },
      name: '视频/文档管理'
    },
    {
      path: '/module/system/sysFastdfsDocment/sysFastdfsDocmentAttach',
      component: resolve => require(['../module/system/sysFastdfsDocment/sysFastdfsDocmentAttach.vue'], resolve),
      meta: {
        title: '上传视频/文档',
        permission: false,
        keepAlive: true,
        idj: ''
      },
      name: '上传视频/文档'
    },
    {
      path: '/page/404',
      component: resolve => require(['../components/page/404.vue'], resolve),
      meta: {
        title: '404'
      },
      name: '404'
    },
    {
      path: '/page/403',
      component: resolve => require(['../components/page/403.vue'], resolve),
      meta: {
        title: '403'
      },
      name: '403'
    }
    ]
  },
  {
    path: '/login',
    component: resolve => require(['../components/page/Login.vue'], resolve)
  },
  {
    path: '*',
    redirect: '/page/404',
    name: '404'
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js